export default __webpack_public_path__ + "static/media/skoll.379aff36.png";